import React from 'react';
import './App.css';

const articles = [
  {
    title: 'Presumption Before Prayer: Reassessing Section 6 of the MFLO 1961',
    status: 'Unpublished manuscript',
    statusClass: 'unpublished',
    publication: 'Family law · 8-page PDF',
    description:
      'A reassessment of the prospective permission requirement for a subsequent marriage under Section 6 of the Muslim Family Laws Ordinance 1961.',
    topics: ['Family law', 'MFLO 1961', 'Islamic jurisprudence'],
    href: '/articles/presumption-before-prayer.pdf',
    format: 'PDF',
  },
  {
    title: 'Audi Alteram Partem Before the Creation of the World',
    status: 'Unpublished manuscript',
    statusClass: 'unpublished',
    publication: 'Civil procedure · Browser reader',
    description:
      'Natural justice, Order 37 of the Civil Procedure Code, and financial-recovery proceedings considered through Qur’anic and constitutional principles.',
    topics: ['Natural justice', 'Order 37 CPC', 'Qur’anic injunctions'],
    href: '/articles/natural-justice-order-37.html',
    format: 'HTML',
  },
  {
    title: 'The Place and Respect of Women in Islam',
    status: 'Unpublished manuscript',
    statusClass: 'unpublished',
    publication: 'Islamic law · Browser reader',
    description:
      'A Qur’anic and fiqhi perspective on women’s legal status, rights, and dignity in the context of contemporary Pakistan.',
    topics: ['Women and law', 'Fiqh', 'Pakistani law'],
    href: '/articles/women-in-islam.html',
    format: 'HTML',
  },
  {
    title: 'Hawala in the Age of Crypto',
    status: 'Research paper',
    statusClass: 'available',
    publication: 'Financial regulation · 8-page PDF',
    description:
      'A reassessment of Pakistan’s anti-money-laundering framework for informal value-transfer systems and emerging cryptocurrency settlement channels.',
    topics: ['Hawala and hundi', 'Money laundering', 'Cryptocurrency'],
    href: '/articles/hawala-in-age-of-crypto.pdf',
    format: 'PDF',
  },
  {
    title: 'Two Fingers, One Verdict',
    status: 'Research paper',
    statusClass: 'available',
    publication: 'Criminal jurisprudence · 13-page PDF',
    description:
      'A constitutional, comparative, and Hanafi examination of the two-finger test in Pakistani rape jurisprudence.',
    topics: ['Constitutional law', 'Criminal law', 'Human dignity'],
    href: '/articles/two-finger-test.pdf',
    format: 'PDF',
  },
  {
    title: 'Between Constitutional Protection and Lived Exploitation',
    status: 'Research paper',
    statusClass: 'available',
    publication: 'Constitutional law · Browser reader',
    description:
      'A critical assessment of the Khwaja Sira community and the Transgender Persons (Protection of Rights) Act 2018 in Pakistan.',
    topics: ['Khwaja Sira', 'Transgender rights', 'Public policy'],
    href: '/articles/khwaja-sira-third-gender.html',
    format: 'HTML',
  },
  {
    title: 'The Place of Death Across Borders',
    status: 'Research paper',
    statusClass: 'available',
    publication: 'Succession law · Browser reader',
    description:
      'Conflicts between Pakistani Islamic succession law and Western probate systems for overseas Pakistani estates.',
    topics: ['Succession', 'Probate', 'Overseas Pakistanis'],
    href: '/articles/place-of-death-across-borders.html',
    format: 'HTML',
  },
  {
    title: 'The Commercialisation of Nikah Halala in Pakistan',
    status: 'Research paper',
    statusClass: 'available',
    publication: 'Family law · Browser reader',
    description:
      'A critical re-examination of the law, jurisprudence, and exploitation associated with commercialised nikah halala practices.',
    topics: ['Nikah halala', 'Family law', 'Women’s rights'],
    href: '/articles/halala-commercialisation.html',
    format: 'HTML',
  },
  {
    title: 'Islamic Banking: Halal or Haram?',
    status: 'Research paper',
    statusClass: 'available',
    publication: 'Banking law · Browser reader',
    description:
      'The accountant’s verdict and the regulator’s confession: a critical legal and financial analysis of Islamic banking in Pakistan.',
    topics: ['Islamic banking', 'Riba', 'Financial regulation'],
    href: '/articles/islamic-banking-halal-or-haram.html',
    format: 'HTML',
  },
  {
    title: 'Islamic Banking in Pakistan: Shariah Compliance or Rebranded Riba?',
    status: 'Journal manuscript',
    statusClass: 'journal',
    publication: 'JIMF-formatted manuscript · Browser reader',
    description:
      'A critical analysis of Islamic banking structures, regulatory oversight, and substantive Shariah compliance in Pakistan.',
    topics: ['Islamic finance', 'Shariah compliance', 'Banking law'],
    href: '/articles/islamic-banking-pakistan.html',
    format: 'HTML',
  },
  {
    title: 'Khulʿ in Pakistan: Between Sharīʿah Principle and Judicial Practice',
    status: 'Research paper',
    statusClass: 'available',
    publication: 'Family law · Browser reader',
    description:
      'A practitioner’s critical analysis of the Sharīʿah basis, financial consequences, and judicial administration of khulʿ in Pakistan.',
    topics: ['Khulʿ', 'Family courts', 'Sharīʿah'],
    href: '/articles/khula-in-pakistan.html',
    format: 'HTML',
  },
  {
    title: 'Nikah and Talaq in Islamic Law',
    status: 'Research paper',
    statusClass: 'available',
    publication: 'Family law · Browser reader',
    description:
      'Qur’anic injunctions, Hanafi jurisprudence, and the Muslim Family Laws Ordinance 1961 considered together.',
    topics: ['Nikah', 'Talaq', 'MFLO 1961'],
    href: '/articles/nikah-talaq-mflo.html',
    format: 'HTML',
  },
  {
    title: 'Second Marriage and Polygyny in Pakistan',
    status: 'Research paper',
    statusClass: 'available',
    publication: 'Family law · Browser reader',
    description:
      'Reconciling Qur’anic conditionality, Hanafi doctrine, and Pakistan’s statutory regulation of polygyny.',
    topics: ['Polygyny', 'Section 6 MFLO', 'Hanafi doctrine'],
    href: '/articles/second-marriage-polygyny.html',
    format: 'HTML',
  },
  {
    title: 'The Architect Behind the Judgment',
    status: 'Professional commentary',
    statusClass: 'commentary',
    publication: 'Civil litigation · Browser reader',
    description:
      'Pleadings, issue framing, and the unseen craft that shapes civil judgments and litigation outcomes in Pakistan.',
    topics: ['Civil litigation', 'Pleadings', 'Legal training'],
    href: '/articles/architect-behind-judgment.html',
    format: 'HTML',
  },
  {
    title: 'The Obligation to Charge Professional Fees',
    status: 'Professional commentary',
    statusClass: 'commentary',
    publication: 'Professional practice · Browser reader',
    description:
      'Why young lawyers must properly value and bill for every professional legal service they render.',
    topics: ['Legal profession', 'Professional fees', 'Young lawyers'],
    href: '/articles/obligation-to-charge-fees.html',
    format: 'HTML',
  },
];

function Articles() {
  return (
    <main className="articles-page">
      <section className="section-head articles-head">
        <p className="eyebrow">Legal Scholarship</p>
        <h2>Articles, journal submissions, and working papers</h2>
        <p>
          Research and commentary by Muhammad Irfan Haroon, Advocate Supreme Court of Pakistan, drawing on more than
          three decades of legal practice.
        </p>
      </section>

      <section className="articles-status-strip" aria-label="Publication status summary">
        <div>
          <strong>15</strong>
          <span>Unique papers</span>
        </div>
        <div>
          <strong>12</strong>
          <span>Browser readers</span>
        </div>
        <div>
          <strong>3</strong>
          <span>Original PDFs</span>
        </div>
      </section>

      <section className="articles-list" aria-labelledby="articles-list-title">
        <div className="articles-list-head">
          <p className="eyebrow">Selected Writing</p>
          <h2 id="articles-list-title">Current manuscripts</h2>
          <p>All listed papers are available to read online.</p>
        </div>

        <div className="article-grid">
          {articles.map(({ title, status, statusClass, publication, description, topics, href, format }) => (
            <article className="article-entry" key={title}>
              <div className="article-meta">
                <span className={`article-status article-status-${statusClass}`}>{status}</span>
                <span className="article-publication">{publication}</span>
              </div>
              <h3>{title}</h3>
              <p>{description}</p>
              <ul className="article-topics" aria-label="Topics">
                {topics.map((topic) => (
                  <li key={topic}>{topic}</li>
                ))}
              </ul>
              <div className="article-actions">
                <a href={href} className="article-read-link" target="_blank" rel="noopener noreferrer">
                  View paper <span aria-hidden="true">↗</span>
                </a>
                <span>{format}</span>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="contact-cta articles-cta">
        <p className="eyebrow">Academic correspondence</p>
        <h2>For editorial or research inquiries</h2>
        <p>Please contact the author regarding citations, journal correspondence, or discussion of the research.</p>
        <div className="cta-actions">
          <a className="button button-gold" href="mailto:irfanharoon@irfanharoonassociates.com">
            Email the author
          </a>
        </div>
      </section>
    </main>
  );
}

export default Articles;
